
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/boatsetter-and-gmb",
      function () {
        return require("private-next-pages/boatsetter-and-gmb.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/boatsetter-and-gmb"])
      });
    }
  